export enum CandidateMoveOption {
    MOVE_TO_END,
    MOVE_TO_ORDER
}

export const CandidateMoveOptionLabel = {
    [CandidateMoveOption.MOVE_TO_END]: 'lang.replacement.moveCandidateToEnd',
    [CandidateMoveOption.MOVE_TO_ORDER]: 'lang.replacement.moveCandidateToPosition'
};
